import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { allowedCommissionTypes } from 'pages/finance/commission/commission/CommissionEnums';
import AgreementCommissionStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/AgreementCommissionStageSteps';
import { AgreementCompliancePageProps } from 'pages/allTasks/TaskModal/AgreementCompliancePageProps';

const QldAgreementCommissionPage = ({
  task,
  toggleTaskStep,
  commissionDetails,
  currentCommissionInfo,
  onCommissionUpdated,
  registerTaskModalPageValidation,
}: AgreementCompliancePageProps) => {
  const commissionStep = task.taskSteps?.find((step) => step.order === 10);

  if (!commissionStep) {
    throw new Error('QLD Agreement Compliance commission step is missing');
  }

  if (!onCommissionUpdated) {
    return null;
  }

  const updateCommissionTaskStep = (isCompleted: boolean) => {
    toggleTaskStep(commissionStep.order ?? 0, isCompleted);
  };

  return (
    <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
      <AgxTypography size="large" type="label" id="step3title" color="var(--text-primary)">
        Step 3 : Commission
      </AgxTypography>
      <AgreementCommissionStageSteps
        commissionDetails={commissionDetails}
        onCommissionUpdated={onCommissionUpdated}
        allowedCommissionTypes={allowedCommissionTypes}
        currentCommissionInfo={currentCommissionInfo}
        commissionStep={commissionStep}
        updateCommissionTaskStep={updateCommissionTaskStep}
        registerTaskModalPageValidation={registerTaskModalPageValidation}
      />
    </AgxSpacer>
  );
};

export default QldAgreementCommissionPage;
